import React, { useMemo } from "react";
import { EntityTablePage, DeleteConfirmationConfig } from "@/components/EntityTablePage";
import { getApplicationTableConfig } from "@/config/tableConfigs/applicationTableConfig";
import { applicationService } from "@/services/applicationService";
import { ApplicationType } from "@/types/db/applications";
import useAuth from "@/hooks/useAuth";
import { DeleteApplicationModal } from "@/components/Modals/DeleteApplicationModal";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useSetPageTitle } from "@/hooks/useSetPageTitle";

export default function ApplicationsPage() {
  const { userRoles, displayNames } = useAuth();
  const tableConfig = getApplicationTableConfig(userRoles, displayNames);
  useSetPageTitle(displayNames?.applications?.plural);

  const deleteConfirmation: DeleteConfirmationConfig<ApplicationType> = useMemo(
    () => ({
      storageKey: "application_delete_skip_confirmation",
      renderModal: ({ count, onConfirm, onCancel }) => (
        <DeleteApplicationModal
          count={count}
          onConfirm={async (dontShowAgain) => {
            if (dontShowAgain) {
              await AsyncStorage.setItem("application_delete_skip_confirmation", "true");
            }
            onConfirm();
          }}
          onCancel={onCancel}
        />
      ),
    }),
    [],
  );

  return (
    <EntityTablePage<ApplicationType>
      {...tableConfig}
      fetchData={applicationService.getApplications}
      updateEntities={applicationService.saveRowPatches}
      deleteEntities={applicationService.deleteApplicationsByIds}
      deleteConfirmation={deleteConfirmation}
    />
  );
}
